var request = require('./request');
var config = require('./config');
var resolveUrl = require('./resolve');

exports.MaskDonation = function(id) {
  return request.put(resolveUrl(config.url(), "/donations/" + id + "/mask")).promise();
};

exports.registerBacsDonation = function (registration) {
  return request
          .post(resolveUrl(config.url(), "/donations/registerBACS"), registration)
          .promise();
};

exports.UpdateShareDetails = function (donationId, shareDetails){
  var params = {
    donationId,
    shareDetails
  };
  return request
          .post(resolveUrl(config.url(), "/donations/updateShareDetails"), params)
          .promise();
};

